import React from 'react';
import './App.css';
import {
    Navigate,
    Route,
    RouterProvider,
    createBrowserRouter,
    createRoutesFromElements,
    redirect,
} from "react-router-dom";
import LogInPage from './pages/Login';
import Dashboard from './pages/Dashboard';
import { PublicCatalogPage } from './pages/PublicCalatog';
import { HomeLayout } from './layout/PublicLayout.js';
import { ProtectedLayout } from './layout/ProtectedLayout';
import EventSelectorView from './pages/PublicEventSelector'
import SetupPage from './pages/SetupPage.js';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { it } from 'date-fns/locale';
import { EventProvider } from './context/eventContext.js';
import { AuthLayout } from './layout/AuthLayout';
import CategoryListPage from './pages/CategoryListPage.js';
import NotFoundPage from './pages/404Page.js';
import CowListPage from './pages/CowListPage.js';
import MatchPage from './pages/MatchPage.js';
import { ThemeProvider } from './context/themeContext.js';
import UserPage from './pages/UserPage.js';
import EventsPage from './pages/EventsPage.js';
import { PublicEventScreen } from './pages/PublicEventScreen.js';
import { PublicMatchPage } from './pages/PublicMatch.js';
import CowmanListPage from './pages/CowmanListPage.js';
import PropertyListPage from './pages/PropertyListPage.js';

const router_p2 = createBrowserRouter(

    createRoutesFromElements(
        <>

            <Route element={<AuthLayout />}
            >
                <Route path="/" element={<EventSelectorView />} />
                <Route element={<HomeLayout />}>
                    <Route path=":event_id/publiccatalog" element={<PublicCatalogPage />} />
                    <Route path="login" element={<LogInPage />} />
                    <Route path=":event_id/login" element={<LogInPage />} />
                    <Route path=":event_id/publicmatch" element={<PublicMatchPage />} />
                </Route>
                <Route element={<ProtectedLayout />}>
                    <Route path=":event_id/dashboard" element={<Dashboard />} />
                    <Route path=":event_id/category" element={<CategoryListPage />} />
                    <Route path=":event_id/match" element={<MatchPage />} />
                    <Route path=":event_id/cowlist" element={<CowListPage />} />
                    <Route path=":event_id/cowmanlist" element={<CowmanListPage />} />
                    <Route path=":event_id/propertylist" element={<PropertyListPage />} />
                    <Route path="eventlist" element={<EventsPage />} />
                    <Route path="setup" element={<EventsPage/>} />
                    <Route path="config" element={<SetupPage />} />
                    <Route path="users" element={<UserPage />} />
                </Route>
                <Route path=":event_id/screen" element={<PublicEventScreen />} />
                <Route path="notpermitted" element={<Navigate to="/login" replace />} />
                <Route path="*" element={<NotFoundPage />} />
            </Route>
        </>
    )
);



function App() {
    return (
        <EventProvider >
            <ThemeProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
                    <RouterProvider router={router_p2} fallbackElement={<p>Loading ...</p>} />
                </LocalizationProvider>
            </ThemeProvider>
        </EventProvider>
    );
}



export default App;
